import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import createLogger from 'vuex/dist/logger'
import account from './modules/account'
import user from './modules/user'
import google from './modules/google'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
	modules: {
		account,
		user,
		google
	},
	actions: {
		clearVuexStore ({ commit }) {
			commit(types.CLEAR_ACCOUNT_VARIABLES)
			commit(types.CLEAR_USER_VARIABLES)
		}
	},
	strict: debug,
	plugins: debug ? [createLogger()] : []
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js